
import { FormData, initialFormData } from '../types';

const FORM_DATA_KEY = 'uaeTaxFormData';

export const saveForm = (data: FormData): void => {
  try {
    localStorage.setItem(FORM_DATA_KEY, JSON.stringify(data));
  } catch (error) {
    console.error("Error saving form data to localStorage:", error);
  }
};

export const loadForm = (): FormData | null => {
  try {
    const data = localStorage.getItem(FORM_DATA_KEY);
    if (data) {
      const parsedData = JSON.parse(data);
      // Basic migration: ensure all top-level keys from initialFormData exist
      const migratedData = { ...initialFormData };
      for (const key in initialFormData) {
        if (parsedData.hasOwnProperty(key)) {
           migratedData[key as keyof FormData] = {
            ...(initialFormData[key as keyof FormData] as any), // Default values for nested objects
            ...(parsedData[key as keyof FormData] as any), // Overwrite with loaded values
          };
        }
      }
      return migratedData as FormData;
    }
  } catch (error) {
    console.error("Error loading form data from localStorage:", error);
  }
  return null;
};

export const clearForm = (): void => {
  try {
    localStorage.removeItem(FORM_DATA_KEY);
  } catch (error) {
    console.error("Error clearing form data from localStorage:", error);
  }
};
